import GrantDiscoveryAccess from "./GrantDiscoveryAccess";

export default GrantDiscoveryAccess;
